// @flow
import Value from '../ui/Value'

const commandJson = (type: string, parentDeleted?: boolean): ((child: Value) => ?any) => (child: Value): ?Object => {
  const {
    databaseId,
    isDeleted,
    isNew,
    isUnchanged,
    nextValue,
  } = child

  if (isDeleted || !!parentDeleted)
    return {type: `Destroy${type}`, databaseId}

  if (isUnchanged)
    return null

  return {
    type: isNew ? `Create${type}` : `Update${type}`,
    description: nextValue,
    databaseId,
  }
}

const childrenJson = (...children: $ReadOnlyArray<$ReadOnlyArray<?Object>>): Array<
  $NonMaybeType<
    $Call<(<X>($ReadOnlyArray<X>) => X) & (<X>(X) => X), $ReadOnlyArray<?any>>,
  >,
> => children.flat().filter(Boolean)

export {
  childrenJson,
  commandJson,
}
